/**
 * Les routes poussées du lot de l'entrée du live : celles qu'il fait passer sur le design system.
 *
 * `pre-call`, l'avant-séance que « GO ! » pousse hors live : le test du matériel, le choix du
 * navigateur, l'entrée, et le starting block en plein écran avant d'entrer
 * (`StudentLiveEntryScreen`).
 *
 * Inscrite `livesInLive` alors que la route n'existe pas dans la pile du live : c'est pour l'instant
 * où l'élève entre. `setIsLiveModeEnabled` passe le pont en live un rendu AVANT que la pile ne bascule ;
 * une entrée simple remplaçait alors l'écran par l'ancien `PreCallScreen`, qui montait le temps d'un
 * rendu, rouvrait ses sondes et renvoyait un second `precall.opened`. Le même écran reste, puis la
 * pile l'emporte.
 *
 * Une entrée inscrite seule ne vaut que hors live ; `livesInLive(écran)` la rend aussi en live
 * (`studentSpaceRouteTypes.ts`). Un écran se charge à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../loadedOnRender"
import { livesInLive, type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

export const liveEntryRoutes: StudentSpaceRouteTable<"liveEntry"> = {
    "pre-call": livesInLive(
        loadedOnRender(
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            () => require("./StudentLiveEntryScreen").StudentLiveEntryScreen,
            "StudentLiveEntryScreen"
        )
    ),
}
